/* tslint:disable */
import {
  HouseInspection,
  InspectionRoom
} from '../index';

declare var Object: any;
export interface InspectionFileInterface {
  "id"?: number;
  "house_inspection_id": number;
  "inspection_room_id": number;
  "file_path": string;
  "file_type"?: string;
  "original_filename"?: string;
  "caption"?: string;
  "file_size"?: number;
  "mime_type"?: string;
  "uploaded_at"?: Date;
  "display_order"?: number;
  "sync_status"?: string;
  "storageType"?: string;
  "googleDriveFileId"?: string;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  houseInspection?: HouseInspection;
  inspectionRoom?: InspectionRoom;
}

export class InspectionFile implements InspectionFileInterface {
  "id": number;
  "house_inspection_id": number;
  "inspection_room_id": number;
  "file_path": string;
  "file_type": string;
  "original_filename": string;
  "caption": string;
  "file_size": number;
  "mime_type": string;
  "uploaded_at": Date;
  "display_order": number;
  "sync_status": string;
  "storageType": string;
  "googleDriveFileId": string;
  "createdAt": Date;
  "updatedAt": Date;
  houseInspection: HouseInspection;
  inspectionRoom: InspectionRoom;
  constructor(data?: InspectionFileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InspectionFile`.
   */
  public static getModelName() {
    return "InspectionFile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InspectionFile for dynamic purposes.
  **/
  public static factory(data: InspectionFileInterface): InspectionFile{
    return new InspectionFile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InspectionFile',
      plural: 'InspectionFiles',
      path: 'InspectionFiles',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "house_inspection_id": {
          name: 'house_inspection_id',
          type: 'number'
        },
        "inspection_room_id": {
          name: 'inspection_room_id',
          type: 'number'
        },
        "file_path": {
          name: 'file_path',
          type: 'string'
        },
        "file_type": {
          name: 'file_type',
          type: 'string',
          default: 'PHOTO'
        },
        "original_filename": {
          name: 'original_filename',
          type: 'string'
        },
        "caption": {
          name: 'caption',
          type: 'string'
        },
        "file_size": {
          name: 'file_size',
          type: 'number'
        },
        "mime_type": {
          name: 'mime_type',
          type: 'string'
        },
        "uploaded_at": {
          name: 'uploaded_at',
          type: 'Date'
        },
        "display_order": {
          name: 'display_order',
          type: 'number',
          default: 0
        },
        "sync_status": {
          name: 'sync_status',
          type: 'string',
          default: 'PENDING'
        },
        "storageType": {
          name: 'storageType',
          type: 'string'
        },
        "googleDriveFileId": {
          name: 'googleDriveFileId',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        houseInspection: {
          name: 'houseInspection',
          type: 'HouseInspection',
          model: 'HouseInspection',
          relationType: 'belongsTo',
                  keyFrom: 'house_inspection_id',
          keyTo: 'id'
        },
        inspectionRoom: {
          name: 'inspectionRoom',
          type: 'InspectionRoom',
          model: 'InspectionRoom',
          relationType: 'belongsTo',
                  keyFrom: 'inspection_room_id',
          keyTo: 'id'
        },
      }
    }
  }
}
